
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import UTILS from '@/lib/UTILS';
import { getProvince } from '@/lib/italy';

@Component
export default class EditLeadCustomerDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false
  valid = false
  loading = false

  tab: number | null = null

  update = {
    // Contatto
    tipoCliente: 'person',
    ragioneSociale: '',
    partitaIva: '',
    codiceFiscaleAzienda: '',
    nome: '',
    cognome: '',
    codiceFiscale: '',
    telefono: '',
    altroTelefono: '',
    pec: '',
    email: '',
    toponimo: '',
    indirizzo: '',
    civico: '',
    cap: '',
    citta: '',
    provincia: '',

    // Fatturazione
    hasBilling: false,
    billingType: 'person',
    billingCompany: '',
    billingVAT: '',
    billingCompanyTaxCode: '',
    billingFirstName: '',
    billingLastName: '',
    billingTaxCode: '',
    billingPhone1: '',
    billingPhone2: '',
    billingPEC: '',
    billingEmail: '',
    billingToponym: '',
    billingStreet: '',
    billingHouseNumber: '',
    billingPostalCode: '',
    billingLocation: '',
    billingProvince: '',

    // Bolletta
    hasInstallation: false,
    installationType: 'person',
    installationCompany: '',
    installationVAT: '',
    installationCompanyTaxCode: '',
    installationFirstName: '',
    installationLastName: '',
    installationTaxCode: '',
    installationPhone1: '',
    installationPhone2: '',
    installationPEC: '',
    installationEmail: '',
    installationToponym: '',
    installationStreet: '',
    installationHouseNumber: '',
    installationPostalCode: '',
    installationLocation: '',
    installationProvince: '',

    // Bolletta (Indirizzo di residenza dell'intestatario della fornitura)
    hasInstallationResidence: false,
    installationResidenceToponym: '',
    installationResidenceStreet: '',
    installationResidenceHouseNumber: '',
    installationResidencePostalCode: '',
    installationResidenceLocation: '',
    installationResidenceProvince: '',
  }

  get pecRules() {
    return [
      (v: string) => !v || /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        .test(v) || "L'indirizzo PEC non è un indirizzo corretto",
    ];
  }

  get emailRequiredRules() {
    return [
      (v: string) => !!v || "L'indirizzo email è richiesto",
      (v: string) => /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        .test(v) || "L'indirizzo email non è un indirizzo corretto",
    ];
  }

  get emailRules() {
    return [
      (v: string) => !v || /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        .test(v) || "L'indirizzo email non è un indirizzo corretto",
    ];
  }

  @Watch('value')
  onValueChange(val: boolean) {
    if (val === true) {
      this.tab = 0;

      // Contatto
      this.$set(this.update, 'tipoCliente', this.lead.tipoCliente);
      this.$set(this.update, 'ragioneSociale', this.lead.ragioneSociale);
      this.$set(this.update, 'partitaIva', this.lead.partitaIva);
      this.$set(this.update, 'codiceFiscaleAzienda', this.lead.codiceFiscaleAzienda);
      this.$set(this.update, 'nome', this.lead.nome);
      this.$set(this.update, 'cognome', this.lead.cognome);
      this.$set(this.update, 'codiceFiscale', this.lead.codiceFiscale);
      this.$set(this.update, 'telefono', this.lead.telefono);
      this.$set(this.update, 'altroTelefono', this.lead.altroTelefono);
      this.$set(this.update, 'pec', this.lead.pec);
      this.$set(this.update, 'email', this.lead.email);
      this.$set(this.update, 'toponimo', this.lead.toponimo);
      this.$set(this.update, 'indirizzo', this.lead.indirizzo);
      this.$set(this.update, 'civico', this.lead.civico);
      this.$set(this.update, 'cap', this.lead.cap);
      this.$set(this.update, 'citta', this.lead.citta);
      this.$set(this.update, 'provincia', this.lead.provincia);

      // Fatturazione
      this.$set(this.update, 'hasBilling', this.lead.hasBilling);
      this.$set(this.update, 'billingType', this.lead.billingType || 'person');
      this.$set(this.update, 'billingCompany', this.lead.billingCompany);
      this.$set(this.update, 'billingVAT', this.getCustomValueTextByName('billingVAT'));
      this.$set(this.update, 'billingCompanyTaxCode', this.getCustomValueTextByName('billingCompanyTaxCode'));
      this.$set(this.update, 'billingFirstName', this.lead.billingFirstName);
      this.$set(this.update, 'billingLastName', this.lead.billingLastName);
      this.$set(this.update, 'billingTaxCode', this.getCustomValueTextByName('billingTaxCode'));
      this.$set(this.update, 'billingPhone1', this.getCustomValueTextByName('billingPhone1'));
      this.$set(this.update, 'billingPhone2', this.getCustomValueTextByName('billingPhone2'));
      this.$set(this.update, 'billingPEC', this.getCustomValueTextByName('billingPEC'));
      this.$set(this.update, 'billingEmail', this.getCustomValueTextByName('billingEmail'));
      this.$set(this.update, 'billingToponym', this.getCustomValueTextByName('billingToponym'));
      this.$set(this.update, 'billingStreet', this.getCustomValueTextByName('billingStreet'));
      this.$set(this.update, 'billingHouseNumber', this.getCustomValueTextByName('billingHouseNumber'));
      this.$set(this.update, 'billingPostalCode', this.getCustomValueTextByName('billingPostalCode'));
      this.$set(this.update, 'billingLocation', this.getCustomValueTextByName('billingLocation'));
      this.$set(this.update, 'billingProvince', this.getCustomValueTextByName('billingProvince'));

      // Bolletta
      this.$set(this.update, 'hasInstallation', this.lead.hasInstallation);
      this.$set(this.update, 'installationType', this.lead.installationType || 'person');
      this.$set(this.update, 'installationCompany', this.lead.installationCompany);
      this.$set(this.update, 'installationVAT', this.getCustomValueTextByName('installationVAT'));
      this.$set(this.update, 'installationCompanyTaxCode', this.getCustomValueTextByName('installationCompanyTaxCode'));
      this.$set(this.update, 'installationFirstName', this.lead.installationFirstName);
      this.$set(this.update, 'installationLastName', this.lead.installationLastName);
      this.$set(this.update, 'installationTaxCode', this.getCustomValueTextByName('installationTaxCode'));
      this.$set(this.update, 'installationPhone1', this.getCustomValueTextByName('installationPhone1'));
      this.$set(this.update, 'installationPhone2', this.getCustomValueTextByName('installationPhone2'));
      this.$set(this.update, 'installationPEC', this.getCustomValueTextByName('installationPEC'));
      this.$set(this.update, 'installationEmail', this.getCustomValueTextByName('installationEmail'));
      this.$set(this.update, 'installationToponym', this.getCustomValueTextByName('installationToponym'));
      this.$set(this.update, 'installationStreet', this.getCustomValueTextByName('installationStreet'));
      this.$set(this.update, 'installationHouseNumber', this.getCustomValueTextByName('installationHouseNumber'));
      this.$set(this.update, 'installationPostalCode', this.getCustomValueTextByName('installationPostalCode'));
      this.$set(this.update, 'installationLocation', this.lead.installationLocation);
      this.$set(this.update, 'installationProvince', this.lead.installationProvince);

      // Bolletta (residenza)
      this.$set(this.update, 'hasInstallationResidence', this.getCustomValueBooleanByName('hasInstallationResidence') ?? false);
      this.$set(this.update, 'installationResidenceToponym', this.getCustomValueTextByName('installationResidenceToponym'));
      this.$set(this.update, 'installationResidenceStreet', this.getCustomValueTextByName('installationResidenceStreet'));
      this.$set(this.update, 'installationResidenceHouseNumber', this.getCustomValueTextByName('installationResidenceHouseNumber'));
      this.$set(this.update, 'installationResidencePostalCode', this.getCustomValueTextByName('installationResidencePostalCode'));
      this.$set(this.update, 'installationResidenceLocation', this.getCustomValueTextByName('installationResidenceLocation'));
      this.$set(this.update, 'installationResidenceProvince', this.getCustomValueTextByName('installationResidenceProvince'));
    }
    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get lead() {
    return this.$store.getters.currentLead;
  }

  get toponimoOptions() {
    return [
      { text: 'Via', value: 'via' },
      { text: 'Piazza', value: 'piazza' },
      { text: 'Corso', value: 'corso' },
      { text: 'Viale', value: 'viale' },
      { text: 'Largo', value: 'largo' },
      { text: 'Vicolo', value: 'vicolo' },
      { text: 'Strada', value: 'strada' },
    ];
  }

  get provinces() {
    return getProvince();
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  getCustomValueTextByName(name: string): string | null {
    return UTILS.getCustomValueTextByName(this.lead, name) || null;
  }

  getCustomValueBooleanByName(name: string): boolean | null {
    return UTILS.getCustomValueBooleanByName(this.lead, name);
  }

  isBusiness(type = ''): boolean {
    switch (type) {
      case 'billing':
        return this.update
          && 'billingType' in this.update
          && this.update.billingType === 'business';

      case 'installation':
        return this.update
          && 'installationType' in this.update
          && this.update.installationType === 'business';

      default:
        break;
    }

    return this.update
      && 'tipoCliente' in this.update
      && this.update.tipoCliente === 'business';
  }

  isPerson(type = ''): boolean {
    switch (type) {
      case 'billing':
        return this.update
          && 'billingType' in this.update
          && this.update.billingType === 'person';

      case 'installation':
        return this.update
          && 'installationType' in this.update
          && this.update.installationType === 'person';

      default:
        break;
    }

    return this.update
      && 'tipoCliente' in this.update
      && this.update.tipoCliente === 'person';
  }

  onDuplicateContactTo(type) {
    switch (type) {
      case 'billing':
        this.update.billingType = this.update.tipoCliente;
        this.update.billingCompany = this.update.ragioneSociale;
        this.update.billingVAT = this.update.partitaIva;
        this.update.billingCompanyTaxCode = this.update.codiceFiscaleAzienda;
        this.update.billingFirstName = this.update.nome;
        this.update.billingLastName = this.update.cognome;
        this.update.billingTaxCode = this.update.codiceFiscale;
        this.update.billingPhone1 = this.update.telefono;
        this.update.billingPhone2 = this.update.altroTelefono;
        this.update.billingPEC = this.update.pec;
        this.update.billingEmail = this.update.email;
        this.update.billingToponym = this.update.toponimo;
        this.update.billingStreet = this.update.indirizzo;
        this.update.billingHouseNumber = this.update.civico;
        this.update.billingPostalCode = this.update.cap;
        this.update.billingLocation = this.update.citta;
        this.update.billingProvince = this.update.provincia;
        break;

      case 'installation':
        this.update.installationType = this.update.tipoCliente;
        this.update.installationCompany = this.update.ragioneSociale;
        this.update.installationVAT = this.update.partitaIva;
        this.update.installationCompanyTaxCode = this.update.codiceFiscaleAzienda;
        this.update.installationFirstName = this.update.nome;
        this.update.installationLastName = this.update.cognome;
        this.update.installationTaxCode = this.update.codiceFiscale;
        this.update.installationPhone1 = this.update.telefono;
        this.update.installationPhone2 = this.update.altroTelefono;
        this.update.installationPEC = this.update.pec;
        this.update.installationEmail = this.update.email;
        this.update.installationToponym = this.update.toponimo;
        this.update.installationStreet = this.update.indirizzo;
        this.update.installationHouseNumber = this.update.civico;
        this.update.installationPostalCode = this.update.cap;
        this.update.installationLocation = this.update.citta;
        this.update.installationProvince = this.update.provincia;
        break;

      default:
        break;
    }
  }

  onDuplicateInstallationTo(type) {
    switch (type) {
      case 'billing':
        this.update.billingType = this.update.installationType;
        this.update.billingCompany = this.update.installationCompany;
        this.update.billingVAT = this.update.installationVAT;
        this.update.billingCompanyTaxCode = this.update.installationCompanyTaxCode;
        this.update.billingFirstName = this.update.installationFirstName;
        this.update.billingLastName = this.update.installationLastName;
        this.update.billingTaxCode = this.update.installationTaxCode;
        this.update.billingPhone1 = this.update.installationPhone1;
        this.update.billingPhone2 = this.update.installationPhone2;
        this.update.billingPEC = this.update.installationPEC;
        this.update.billingEmail = this.update.installationEmail;
        this.update.billingToponym = this.update.installationToponym;
        this.update.billingStreet = this.update.installationStreet;
        this.update.billingHouseNumber = this.update.installationHouseNumber;
        this.update.billingPostalCode = this.update.installationPostalCode;
        this.update.billingLocation = this.update.installationLocation;
        this.update.billingProvince = this.update.installationProvince;
        break;

      default:
        break;
    }
  }

  onDuplicateBillingTo(type) {
    switch (type) {
      case 'installation':
        this.update.installationType = this.update.billingType;
        this.update.installationCompany = this.update.billingCompany;
        this.update.installationVAT = this.update.billingVAT;
        this.update.installationCompanyTaxCode = this.update.billingCompanyTaxCode;
        this.update.installationFirstName = this.update.billingFirstName;
        this.update.installationLastName = this.update.billingLastName;
        this.update.installationTaxCode = this.update.billingTaxCode;
        this.update.installationPhone1 = this.update.billingPhone1;
        this.update.installationPhone2 = this.update.billingPhone2;
        this.update.installationPEC = this.update.billingPEC;
        this.update.installationEmail = this.update.billingEmail;
        this.update.installationToponym = this.update.billingToponym;
        this.update.installationStreet = this.update.billingStreet;
        this.update.installationHouseNumber = this.update.billingHouseNumber;
        this.update.installationPostalCode = this.update.billingPostalCode;
        this.update.installationLocation = this.update.billingLocation;
        this.update.installationProvince = this.update.billingProvince;
        break;

      default:
        break;
    }
  }

  onCancel() {
    this.dialog = false;
  }

  async onUpdate() {
    if (this.form.validate()) {
      this.loading = true;

      await this.$store.dispatch('updateLead', {
        updateType: 'customer',
        update: this.update,
      });

      this.dialog = false;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  }
}
